module.exports = __webpack_public_path__ + "assets/img/u16510.a7000a5f.png";